import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { SplashScreenService } from '@core/services/splash-screen.service';
import { DevToolSheetComponent } from 'app/dev-tools/dev-tool-sheet/dev-tool-sheet.component';
import { environment } from 'env';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatSidenavModule, MatButtonModule, MatIconModule, MatListModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'y-project';
  isProductionMode = environment.production;
  _bottomSheet = inject(MatBottomSheet);
  _router = inject(Router);
  splashScreenService = inject(SplashScreenService);

  constructor() {
    this._router.initialNavigation();
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd || event instanceof NavigationError) {
        this.splashScreenService.hide();
      }
    });
  }

  openBottomSheet(): void {
    this._bottomSheet.open(DevToolSheetComponent);
  }
}
